<template>
  <a-modal
    :title="isEdit ? $t('edit') : $t('create')"
    :visible="visible"
    @ok="() => save()"
    @cancel="() => cancel()"
  >
    <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
      <a-form-item :label="$t('page_organization_department_name')">
        <a-input
          v-decorator="[
            'postName',
            {
              initialValue: (isEdit && editItem.postName) || '',
              rules: [{ required: true, message: $t('page_organization_enter_department_name') }]
            }
          ]"
          :placeholder="$t('page_organization_enter_department_name')"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { PostServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const psp = new PostServiceProxy()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    editItem: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this)
    }
  },
  methods: {
    cancel() {
      this.form.resetFields()
      this.$emit('cancel')
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.isEdit && this.editItem && this.editItem.id) {
            values.id = this.editItem.id
          }
          psp.submit(values).then(() => {
            this.$message.success(this.isEdit ? this.$t('page_ops_customer_edit_succee') : this.$t('page_ops_customer_new_success'))
            this.$emit('save')
            this.form.resetFields()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
